import * as PIXI from "pixi.js-legacy"

import * as Utils from "./utils"
import Slice from "./Slice"

export default class SequenceSlice extends Slice {

	// Overflow and fit information come from the parent linkObject
	constructor(resourceDataArray, duration, overflow, fit, player) {
		super(null, overflow, fit, player)
		this._resourceDataArray = resourceDataArray
		this._duration = (Utils.isANumber(duration) === true && duration > 0) ? duration : 0
		this._resourceType = "sequence"
	}

	finishBuilding() {
		// Create the texturesArray and create an AnimatedSprite if possible
		const texturesArray = this._createTexturesArray()
		if (texturesArray.length === 0) {
			return
		}
		this._playableSprite = this._createAndAddAnimatedSprite(texturesArray)
		this._playableSprite.loop = false
		this._centerAndClipIfNeeded()
	}

	_createAndAddAnimatedSprite(texturesArray) {
		const sprite = new PIXI.AnimatedSprite(texturesArray)
		this._container.addChild(sprite)
		return sprite
	}

	_createTexturesArray() {
		let texturesArray = []
		if (this._resourceDataArray && this._resourceDataArray.length > 0) {

			// Build texturesList
			const texturesList = []
			this._resourceDataArray.forEach((resourceData) => {
				const { path, mediaFragmentString } = resourceData
				const texture = this._getTextureFromPath(path, mediaFragmentString)
				if (texture) {
					// Get natural dimensions from the first texture in the list
					if (texture && (!this._naturalWidth || !this._naturalHeight)) {
						this._naturalWidth = texture.width
						this._naturalHeight = texture.height
					}
					texturesList.push(texture)
				}
			})

			// Now build texturesArray with time information
			if (texturesList.length > 0) {
				// Compute how long each image will be displayed
				// Note that the textures that have not been created are skipped,
				// meaning that the total number of textures may be less than planned,
				// and thus the time spent on each actual texture longer than expected
				const time = this._duration / this._resourceDataArray.length
				texturesArray = texturesList.map((texture) => ({ texture, time }))
			}

		}
		return texturesArray
	}

	play() {
		if (this._playableSprite) {
			this._playableSprite.play()
		}
	}

	gotoAndStop(frameNumber) {
		if (this._playableSprite) {
			this._playableSprite.gotoAndStop(frameNumber)
		}
	}

	destroy() {
		if (this._playableSprite && this._playableSprite.textures) {
			const { textures } = this._playableSprite
			textures.forEach((texture) => {
				this._destroyTexture(texture)
			})
		}
	}

}